"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _utils = _interopRequireDefault(require("./utils"));
const DOWNLOAD_REVOKE_DELAY = 100;
// Map to track ongoing downloads
const ongoingDownloads = new Map();
const FileUtils = {
  download(url, name) {
    return (0, _asyncToGenerator2.default)(function* () {
      // Create a unique key for this download request
      const downloadKey = `${url}_${name || ''}`;

      // Check if this download is already in progress
      if (ongoingDownloads.has(downloadKey)) {
        return true; // Return true to indicate to the caller that download is being handled
      }

      // Mark this download as in progress
      ongoingDownloads.set(downloadKey, true);
      try {
        const options = {
          method: 'GET',
          mode: 'cors',
          credentials: 'same-origin'
        };
        const response = yield fetch(url, options);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        let fileName = name;
        if (!fileName) {
          const contentDisposition = response.headers.get('content-disposition');
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = fileNameMatch[1].replace(/['"]/g, '');
            }
          }
          if (!fileName) {
            fileName = url.substring(url.lastIndexOf('/') + 1, url.length);
          }
        }
        const blob = yield response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => {
          URL.revokeObjectURL(blobUrl);
          // Remove this download from the tracking map after completion
          ongoingDownloads.delete(downloadKey);
        }, DOWNLOAD_REVOKE_DELAY);
        return true;
      } catch (e) {
        console.error('Download failed:', e); // eslint-disable-line no-console
        // Remove from tracking map in case of error
        ongoingDownloads.delete(downloadKey);
        return false;
      }
    })();
  },
  _promiseFileReader(file, valueAsArrayBuffer) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onerror = () => {
        reader.abort();
        reject(new DOMException('Problem parsing input file'));
      };
      reader.onload = () => {
        resolve(reader.result);
      };
      if (valueAsArrayBuffer) {
        reader.readAsArrayBuffer(file);
      } else {
        reader.readAsDataURL(file);
      }
    });
  },
  makeFilesArr(filesSource, valueAsArrayBuffer) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const files = [];
      for (let i = 0; i < filesSource.length; i += 1) {
        const file = filesSource[i];
        const value = yield _this._promiseFileReader(file, valueAsArrayBuffer);
        const fileObj = {
          id: `${i.toString()}_${_utils.default.random()}`,
          label: file.name,
          size: file.size,
          type: file.type,
          value,
          fileSource: file
        };
        files.push(fileObj);
      }
      return files;
    })();
  },
  checkFileAccept(file, acceptedFiles) {
    if (file && acceptedFiles) {
      const acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
      const fileName = file.name || '';
      const mimeType = (file.type || '').toLowerCase();
      const baseMimeType = mimeType.replace(/\/.*$/, '');
      return acceptedFilesArray.some(type => {
        const validType = type.trim().toLowerCase();
        if (validType.charAt(0) === '.') {
          return fileName.toLowerCase().endsWith(validType);
        } else if (validType.endsWith('/*')) {
          // This is something like a image/* mime type
          return baseMimeType === validType.replace(/\/.*$/, '');
        }
        return mimeType === validType;
      });
    }
    return true;
  },
  biteToSize(bites) {
    const KB = 1024;
    const MB = KB * 1024;
    if (bites >= MB) {
      return `${(bites / MB).toFixed(2)} MB`;
    } else if (bites >= KB) {
      return `${(bites / KB).toFixed(2)} KB`;
    }
    return `${bites} B`;
  }
};
var _default = exports.default = FileUtils;